import React, { useState, useEffect } from 'react';
import './CalendarioAgendamento.css';
import ButtonLink from '../buttonLinkComponent/ButtonLink';
import { handleResetToHome } from '../../utils/buttonLink';
import { IoCalendarOutline, IoChevronBack, IoChevronForward, IoClose } from 'react-icons/io5';

const CalendarioAgendamento = ({ message, verificaResposta, hasNewerUserMessage, showButtonLink, showHomeLink = showButtonLink }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [visible, setVisible] = useState(false);
    const [isConfirmed, setIsConfirmed] = useState((message.isHistory && hasNewerUserMessage) || false);
    const [hasReturned, setHasReturned] = useState(false);
    const isCalendarDisabled = isConfirmed || hasReturned || hasNewerUserMessage || message.buttonClicked === true;
    
    const [selectedDate, setSelectedDate] = useState(null); // 'DD/MM'
    const [selectedTime, setSelectedTime] = useState(null); // {time, originalOption, index}
    
    // Parses options
    const disponibilidades = {}; 
    const outrasOpcoes = [];
    
    message.options.forEach((option, index) => {
        const textToMatch = option.text.replace(/<[^>]+>/g, '');
        const match = textToMatch.match(/\((\d{2}\/\d{2})\)\s*(.*?),\s*(\d{2}:\d{2})/);
        if (match) {
            const dateKey = match[1];
            const weekday = match[2];
            const time = match[3];
            if (!disponibilidades[dateKey]) disponibilidades[dateKey] = [];
            disponibilidades[dateKey].push({ time, weekday, originalOption: option, index, rawMatch: option.text });
        } else {
            outrasOpcoes.push({ ...option, index });
        }
    });

    const datesAvailable = Object.keys(disponibilidades);
    const datesAvailableStr = datesAvailable.join(',');
    const [currentMonthDate, setCurrentMonthDate] = useState(new Date());

    useEffect(() => {
        if (datesAvailable.length > 0) {
            const [dd, mm] = datesAvailable[0].split('/');
            const year = new Date().getFullYear();
            const currentMonth = new Date().getMonth() + 1;
            const y = parseInt(mm) < currentMonth ? year + 1 : year;
            setCurrentMonthDate(new Date(y, parseInt(mm) - 1, 1));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [datesAvailableStr]);

    const openModal = () => {
        if (isCalendarDisabled) return;
        setIsModalOpen(true);
        setTimeout(() => setVisible(true), 10);
        document.body.classList.add('modal-open');
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setVisible(false);
        setTimeout(() => {
            setIsModalOpen(false);
            setSelectedDate(null);
            setSelectedTime(null);
        }, 300);
        document.body.classList.remove('modal-open');
        document.body.style.overflow = 'unset';
    };

    const nextMonth = () => {
        setCurrentMonthDate(new Date(currentMonthDate.getFullYear(), currentMonthDate.getMonth() + 1, 1));
    };

    const prevMonth = () => {
        setCurrentMonthDate(new Date(currentMonthDate.getFullYear(), currentMonthDate.getMonth() - 1, 1));
    };

    const renderCalendar = () => {
        const year = currentMonthDate.getFullYear();
        const month = currentMonthDate.getMonth();
        
        const firstDay = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        
        const days = [];
        for (let i = 0; i < firstDay; i++) days.push(null);
        for (let i = 1; i <= daysInMonth; i++) days.push(i);
        
        const monthNames = [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
            "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ];
        
        const weekDays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

        return (
            <div className="calendar-wrapper">
                <div className="calendar-header">
                    <button className="month-nav-btn" onClick={prevMonth}><IoChevronBack /></button>
                    <span>{monthNames[month]} {year}</span>
                    <button className="month-nav-btn" onClick={nextMonth}><IoChevronForward /></button>
                </div>
                <div className="calendar-grid">
                    {weekDays.map(wd => <div key={wd} className="calendar-weekday">{wd}</div>)}
                    {days.map((d, i) => {
                        if (!d) return <div key={i} className="calendar-day empty"></div>;
                        const dateKey = `${String(d).padStart(2, '0')}/${String(month + 1).padStart(2, '0')}`;
                        const isAvailable = !!disponibilidades[dateKey];
                        
                        return (
                            <button 
                                key={i} 
                                className={`calendar-day ${isAvailable ? 'available' : 'disabled'}`}
                                onClick={() => isAvailable && setSelectedDate(dateKey)}
                                disabled={!isAvailable}
                            >
                                {d}
                            </button>
                        )
                    })}
                </div>
                <div className="calendar-legend">
                    <span className="legend-item"><div className="legend-color available" /> Datas disponíveis</span>
                    <span className="legend-item"><div className="legend-color disabled" /> Indisponível</span>
                </div>
            </div>
        );
    };

    return (
        <>
        <div className="calendario-agendamento-container">
            <button 
                className={`calendario-agendamento-button ${isCalendarDisabled ? 'disabled' : ''}`}
                onClick={openModal}
                disabled={isCalendarDisabled}
            >
                <div className="calendario-content">
                    <IoCalendarOutline className="calendar-icon" />
                    <span>{isConfirmed ? 'Data selecionada' : 'Escolher dia'}</span>
                </div>
            </button>

            {isModalOpen && (
                <>
                    <div className={`modal-overlay ${visible ? 'visible' : ''}`} onClick={closeModal}></div>
                    <div className={`modal-content-csat calendario-modal ${visible ? 'visible' : ''}`}>
                        <div className="modal-header" style={{ borderBottom: 'none' }}>
                            <h3></h3>
                            <button className="close-button" aria-label="Fechar calendário" onClick={closeModal}>
                                <IoClose />
                            </button>
                        </div>
                        
                        <div className="modal-body slider-container" style={{ borderBottom: 'none', border: 'none', overflow: 'hidden' }}>
                            <div className={`slider-view ${selectedDate ? 'slide-left' : ''}`} style={{ borderBottom: 'none', border: 'none' }}>
                                
                                <div className="calendar-view" style={{ overflowX: 'hidden' }}>
                                    <p className="calendar-instruction">Selecione um dia disponível para ver os horários</p>
                                    {renderCalendar()}
                                    
                                    {outrasOpcoes.length > 0 && (
                                        <div className="outras-opcoes-container">
                                            {outrasOpcoes.map(opt => (
                                                <button 
                                                    key={opt.index} 
                                                    className="outras-opcoes-btn"
                                                    onClick={() => {
                                                        verificaResposta(opt.index, opt.text);
                                                        setIsConfirmed(true);
                                                        closeModal();
                                                    }}
                                                >
                                                    <span dangerouslySetInnerHTML={{ __html: opt.text }} />
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                
                                <div className="times-view" style={{ alignItems: 'flex-start', paddingTop: '0', borderBottom: 'none', border: 'none', overflowX: 'hidden' }}>
                                    <div className="times-header" style={{ width: '100%', justifyContent: 'flex-start', borderBottom: '1px solid #eee', marginBottom: '20px', paddingBottom: '15px' }}>
                                        <button className="back-btn" onClick={() => { setSelectedDate(null); setSelectedTime(null); }} style={{ fontSize: '15px', fontWeight: '500' }}>
                                            &larr; Voltar ao calendário
                                        </button>
                                    </div>
                                    
                                    {selectedDate && disponibilidades[selectedDate] && (
                                        <div style={{ width: '100%', textAlign: 'left', marginBottom: '20px', paddingBottom: '15px', borderBottom: '1px solid #eee' }}>
                                            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#333', marginBottom: '6px' }}>
                                                {disponibilidades[selectedDate][0].weekday}, {selectedDate}
                                            </div>
                                            <div style={{ fontSize: '15px', color: '#666' }}>
                                                Escolha um horário:
                                            </div>
                                        </div>
                                    )}
                                    
                                    <div className="times-grid" style={{ width: '100%', paddingRight: '5px', paddingTop: '5px', borderBottom: 'none', border: 'none' }}>
                                        {selectedDate && disponibilidades[selectedDate] && disponibilidades[selectedDate].map((slot, i) => (
                                            <button 
                                                key={i}
                                                className={`time-slot ${selectedTime?.index === slot.index ? 'selected' : ''}`}
                                                onClick={() => setSelectedTime(slot)}
                                            >
                                                {slot.time.replace(/^0/, '').replace(':', 'h')}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        
                        <div className="calendario-modal-footer" style={{ borderTop: 'none', border: 'none', boxShadow: 'none' }}>
                            <button 
                                className="add-to-cart-button"
                                disabled={!selectedTime && selectedDate}
                                style={{ display: selectedDate ? 'block' : 'none' }}
                                onClick={() => {
                                    if (selectedTime) {
                                        verificaResposta(selectedTime.index, selectedTime.originalOption.text);
                                        setIsConfirmed(true);
                                        closeModal();
                                    }
                                }}
                            >
                                Confirmar horário
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
        {!isModalOpen && (showButtonLink || showHomeLink) && !isCalendarDisabled && (
            <div className="button-link-wrapper">
                {showButtonLink && (
                    <ButtonLink
                        text={message.buttonLinkText}
                        onClick={() => {
                            setHasReturned(true);
                            verificaResposta(null, message.buttonLinkText);
                        }}
                    />
                )}
                {showHomeLink && (
                    <ButtonLink
                        text="Acessar menu inicial"
                        onClick={handleResetToHome}
                    />
                )}
            </div>
        )}
        </>
    );
};

export default CalendarioAgendamento;
